import { USER_ACTION_LOGIN } from "./";

export const UserLogin = (authed, token) => {
  return (dispatch) => {
    dispatch({ type: USER_ACTION_LOGIN, authed, token });
  };
};
